import { createFileRoute } from '@tanstack/react-router'
import { withSessionRedirect } from '../lib/require-session.ts'
import { VaultAudit } from '../components/VaultAudit.tsx'
import { fetchHierarchy } from '../lib/hierarchy-api.ts'
import { listAudit } from '../lib/vault-api.ts'
import { useAutoRefresh } from '../lib/use-auto-refresh.ts'

export const Route = createFileRoute('/vault/audit')({
  loader: async () =>
    withSessionRedirect(async () => {
      const tree = await fetchHierarchy()
      const rootId = tree.roots[0]?.id ?? ''
      if (!rootId) return { rootId, rows: [] }
      const rows = await listAudit(rootId)
      return { rootId, rows }
    }),
  component: VaultAuditRoute,
})

/** Audit rows change on every run/list/get/decide call — track the
 * approvals queue's cadence rather than the daemon page's slower one. */
const REFRESH_MS = 15_000

function VaultAuditRoute() {
  const { rootId, rows } = Route.useLoaderData()
  useAutoRefresh(REFRESH_MS)

  return <VaultAudit rootId={rootId} rows={rows} />
}
